<template>
  <div id="app">
    <app-header></app-header>
    <app-menu :menuList="menuList"></app-menu>
    <app-slider :sliders="mainData.frontSlide"></app-slider>
    <div class="bg-grey">
      <div class="list-inner">
        <div class="list-item">
          <news :listData="mainData.newsInformation" :menu="getLink('155')"/>
        </div>
        <div class="list-item">
          <notice :listData="mainData.announcement" :menu="getLink('154')"/>
        </div>
        <div class="list-item">
          <admissions :listData="mainData.admissionInformation" :menu="getLink('153')"/>
        </div>
        <div class="list-item">
          <export :listData="mainData.downloadCenter" :menu="getLink('156')"/>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
    <bay-window v-if="mainData.bayWindow && Array.isArray(mainData.bayWindow) && mainData.bayWindow[0]" :data="mainData.bayWindow[0]"></bay-window>
  </div>
</template>

<script>
import menus from '@/mixins/menus';
import AppHeader from '@/components/common/Header';
import AppFooter from '@/components/common/Footer';
import AppMenu from '@/components/common/Menu';
import List from '@/components/normalList/List';
import AppSlider from '@/components/slider/Index';
import BayWindow from '@/components/bayWindow/Index';
import Admissions from '@/components/admissions/index';
import Notice from '@/components/notice/index';
import News from '@/components/news/index';
import Export from '@/components/export/index';
import { getMainData } from '@/api';
export default {
  name: 'App',
  mixins: [menus],
  components: {
    AppHeader,
    AppFooter,
    AppMenu,
    List,
    AppSlider,
    BayWindow,
    Admissions,
    Notice,
    News,
    Export
  },
  data() {
    return {
      mainData: {
        admissionInformation : [], // 通知公告
        announcement : [],         // 招生信息
        newsInformation : [],      // 新闻动态
        downloadCenter : [],       // 下载中心
        frontSlide : [],
        friendLink : [],
        bayWindow : null     
      },
    };
  },
  methods: {
    async getMainData() {
      let {
        admissionInformation = [],
        announcement = [],
        newsInformation = [],
        downloadCenter = [],
        frontSlide = [],
        friendLink = [],
        bayWindow = null
      } = await getMainData();
      this.mainData = {
        admissionInformation,
        announcement,
        newsInformation,
        downloadCenter,
        frontSlide,
        friendLink,
        bayWindow,
      };
    },
    getLink(id) {
      return this.allSubTreeList.find(o => o.id == id) || {};
    },
  },
  mounted() {
    this.getMainData();
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/global.scss';
@import '@/assets/styles/variable.scss';
.bg-grey {
  background-color: #ebebeb;
  padding: 40px 0 40px 0;
  .list-inner {
    width: $container_width;
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    box-shadow: 0px 1px 5px 1px #ddd;
    background-color: #fff;
    .list-item{
      width: 25%;
      height: 384px;
      border-right: 1px solid #eee;
    }
  }
}
.normalWidth {
  width: 520px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/App.vue